// removed by extract-text-webpack-plugin
module.exports = {"container":"_1jSPB","avatar":"_2ssUq","details":"_2tyXe","name":"_2K3m7","date":"_1U3kH","stats":"_1Nf9Y","actions":"_3YQpR","moreButton":"_3cxtn","spacer":"K2Bsx","link":"_2uL_p"};


//////////////////
// WEBPACK FOOTER
// ./app/components/member-list-item/member-list-item.scss
// module id = 1608
// module chunks = 0